const messages = {
  title: "Listas de precios y folletos de productos",
  title_media: "Listas de precios y folletos de productos",
  description:
    "Descargue aquí los últimos folletos y material sobre nuestros neumáticos Bridgestone y Firestone para turismos, SUV y vehículos comerciales ligeros.",
  short_description:
    "Aquí puede encontrar recursos para redes sociales, TV en tienda y más.",
  mediaCategories: {
    products: "Productos",
    brand_and_solutions: "Marca y soluciones",
    season_and_promotions: "Temporada y promociones",
    format: "Formato",
    cars_and_vans: "Turismo, SUV, comercial ligero",
    truck_and_buses: "Pesado y autobús",
    motorcycle: "Motocicleta",
    agriculture: "Agricultura",
    construction_machinery: "Maquinaria de construcción",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiales",
    brochures: "Folletos de producto",
    price_list: "Listas de precios",
    materials: "Materiales",
    video_in_store: "Vídeo con subtítulos",
    video_online: "Vídeo sin subtítulos",
    video: "Vídeo",
    banner_website: "Banner",
    banner_social_media: "Redes sociales",
    logos: "Logotipos",
    summer: "Verano",
    winter: "Invierno",
    all_season: "Todas las estaciones",
    promotions: "Promociones",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIATECA",
    description:
      "Bienvenido a la sección de medios dedicada   \n" +
      "a los productos Bridgestone y Firestone.  \n <br> <br>" +
      "Descubrirá imágenes de productos,   \n" +
      "logotipos, así como una amplia selección de   \n" +
      "banners, videos y materiales digitales   \n" +
      "para usar en su sitio web o en las   \n" +
      "redes sociales.  ",
    bDrive: {
      title: "Fotos de productos",
      description:
        "Las imágenes actuales   \n" +
        "pueden descargarse   \n" +
        "desde nuestro portal B-\n" +
        "DRIVE.  ",
    },
  },
  buttons: {
    media: "DESCUBRIR",
  },
  searchMedia: "Introduzca una palabra clave",
  searchResults: "Resultados de búsqueda",
};

export default {
  messages,
};
